<template>
  <div>
    <duo-paper-cut
      :width="width"
      :height="height"
      :srcList="srcList"
      :autoPlay="autoPlay"
      :interval="interval"
      :transition="transition"
      :cutsNumber="cutsNumber"
      :paginationDirection="paginationDirection"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      width: 1200, // 宽度
      height: 560, // 高度
      cutsNumber: 18, // 切割数
      interval: 8000, // 自动轮播间隔时间(单位ms)
      autoPlay: false, // 是否自动轮播
      transition: 1500, // 动画过渡时间(单位ms)
      paginationDirection: "left-bottom", // 分页位置
      srcList: [
        // 图片资源
        "https://images.pexels.com/photos/247431/pexels-photo-247431.jpeg",
        "http://d300.paixin.com/thumbs/1739009/19194001/staff_1024.jpg",
        "https://images.pexels.com/photos/17811/pexels-photo.jpg",
        "http://d300.paixin.com/thumbs/1067920/20205975/staff_1024.jpg",
      ],
    };
  },
};
</script>


<style>
HTML {
  background: #000000;
}
* {
  margin: 0;
  padding: 0;
}
.wrap {
  margin: 40px auto;
  width: 500px;
}
</style>
 


// WEBPACK FOOTER //
// src/App.vue